import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiNotificationsService {

  notificationReadSubject = new Subject<boolean>();

  constructor(
    private apiBasic: ApiBasicService,
    private api: ApiService
  ) { }


  /**
   * 
   * @returns Observable<boolean>
   */
  listenerNotificationRead(): Observable<boolean> {

    return this.notificationReadSubject.asObservable();
  }


  /**
   * 
   * @param state 
   */
  actionNotificationRead(state: boolean): void {

    this.notificationReadSubject.next(state);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName: string): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getListNotifications(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'user_notifications');
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getEmailStateOfNotification(): Observable<Res> {

    return this.api.get('notifications_user_roles_delivery', '', 'private');
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  setEmailStateOfNotification(params:any): Observable<Res> {

    return this.api.post('notifications_user_roles_delivery/create', params, 'private');
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getListNotificationsByRole(params: any): Observable<Res> {

    return this.api.post('notificationPresetList', params, 'private', 'files');

    // return this.apiBasic.getList(params, 'notifications_user_roles_delivery');
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getListNotificationsByChannel(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'notifications_users_delivery');
  }

  /**
  * 
  * @param id string
  * @returns Observable<Res>
  */
  info(id: string): Observable<Res> {

    return this.apiBasic.getInfo('user_notifications', id);
  }

  /**
 * 
 * @param params any
 * @returns Observable<Res>
 */
  createNotificationsUserRoles(params: any): Observable<Res> {

    return this.api.post('notificationPreset', params, 'private', 'files');

    // return this.apiBasic.create('notifications_user_roles_delivery', params);
  }


  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  createNotificationsChannel(params: any): Observable<Res> {

    return this.apiBasic.create('notifications_users_delivery', params);
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  editNotifications(id: string): Observable<Res> {

    return this.apiBasic.edit('user_notifications', id);
  }

  /**
 * 
 * @param id string
 * @returns Observable<Res>
 */
  editNotificationsUserRoles(id: string): Observable<Res> {

    return this.apiBasic.edit('notifications_user_roles_delivery', id);
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  editNotificationsChannel(id: string): Observable<Res> {

    return this.apiBasic.edit('notifications_users_delivery', id);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  updateNotificationsUserRoles(params: any): Observable<Res> {

    return this.apiBasic.update('notifications_user_roles_delivery', params);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  updateNotificationsChannel(params: any): Observable<Res> {

    return this.apiBasic.update('notifications_users_delivery', params);
  }

  /**
  * 
  */
  deleteNotificationsUserRoles(params: any): Observable<Res> {

    return this.api.delete('notificationPreset', params, 'private', 'files');

    // return this.apiBasic.delete('notifications_user_roles_delivery', params);
  }


  /**
  * 
  */
  deleteNotificationsChannel(params: any): Observable<Res> {

    return this.apiBasic.delete('notifications_users_delivery', params);
  }


  /**
  * 
  * @param objectName string
  * @param objectId string
  * @returns Observable<Res>
  */
  changeState(id: any): Observable<Res> {

    return this.apiBasic.changeState('user_notifications', id);
  }


}
